export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/draco.worker.79e84672.worker.js");
}
